//@ts-nocheck
import Spline from '@splinetool/react-spline';

export default function Home() {
  return (
    <main
      style={{
        height: '100%',
      }}
    >
      <Spline scene="https://prod.spline.design/eqxP1gtEKFqeozRj/scene.splinecode" />
    </main>
  );
}
